var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-p5',{on:{"sketch":_vm.sketch}})
}
var staticRenderFns = []

export { render, staticRenderFns }